import React, { useContext } from "react";

import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";
import { round } from "@/utils/number";

import MealPlanFormStore from "../store/MealPlanFormStore";

interface Props {
  name: "carbohydrate" | "protein" | "fat";
  label: string;
  description: string;
}

const useStyles = makeStyles()({
  label: {
    fontWeight: "bold",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#F7F9FB",
    },
    "& .Mui-disabled": {
      color: colors.black,
    },
  },
});

const MacronutrientField: React.FC<Props> = observer(
  ({ label, description, name }) => {
    const { classes } = useStyles();

    const store = useContext(MealPlanFormStore.Context);
    const macronutrients = store.macronutrients;
    const formState = macronutrients.formState;
    const valueGrams = macronutrients[`${name}Grams`];

    return (
      <Box padding={2} border="1px solid #edf0f5">
        <Box>
          <Typography className={classes.label}>{label}</Typography>
          <Typography variant="caption" color="textSecondary">
            {description}
          </Typography>
        </Box>
        <Box marginTop={1}>
          <Box
            display="inline-flex"
            flexDirection="column"
            width="50%"
            paddingRight={2.5}
          >
            <Typography variant="caption" color="textSecondary">
              Percentage
            </Typography>
            <TextField
              className={classes.textField}
              {...formState.field(`${name}s`, { maxDecimalPlace: 0 })}
              error={!!formState.errors[`${name}s`]}
              size="small"
              type="number"
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
          </Box>
          <Box display="inline-flex" flexDirection="column" width="50%">
            <Typography variant="caption" color="textSecondary">
              Grams
            </Typography>
            <TextField
              className={classes.textField}
              disabled
              aria-readonly
              size="small"
              value={round(valueGrams, 2)}
              InputProps={{
                endAdornment: <InputAdornment position="end">g</InputAdornment>,
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
);

export default MacronutrientField;
